import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("admin_token"));
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogin = (token, adminData = null) => {
  setToken(token);
  localStorage.setItem("admin_token", token);

  try {
    const decoded = jwtDecode(token);

    const mergedUser = {
      ...decoded,
      ...adminData,
      userId: adminData?.userId || decoded?.userId,
      role: adminData?.role || decoded?.role,
      email: adminData?.email || decoded?.email,
    };

    localStorage.setItem("uk_user", JSON.stringify(mergedUser));
    localStorage.setItem("uk_role", mergedUser.role);
    localStorage.setItem("uk_userId", mergedUser.userId);

    setAdmin(mergedUser);
    return mergedUser;
  } catch (err) {
    console.error("Failed to decode token:", err);
    return null;
  }
};


  const handleLogout = () => {
    setToken(null);
    setAdmin(null);
    localStorage.removeItem("admin_token");
    toast.info("Logged out successfully");
  };

  useEffect(() => {
    const existingToken = localStorage.getItem("admin_token");

    if (existingToken) {
      try {
        const decoded = jwtDecode(existingToken);

        if (decoded.exp * 1000 < Date.now()) {
          handleLogout();
          toast.info("Session expired. Please login again.");
        } else {
          setToken(existingToken);
          setAdmin(decoded);
        }
      } catch (err) {
        console.error("Invalid token:", err);
        handleLogout();
        toast.info("Session expired. Please login again.");
      }
    }

    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        admin,
        loading,
        setAdmin,
        login: handleLogin,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
